import { FC, ReactNode } from "react";

interface Props {
  title?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}

/** 
 * Wrapper para estandarizar el diseño de todas las pantallas del admin.
 * Crea una tarjeta blanca con sombra suave y un encabezado opcional.
 */
export const PageCard: FC<Props> = ({ title, action, children }) => {
  return (
    <div
      style={{
        background: "#ffffff",
        borderRadius: "16px",
        border: "1px solid #e8edf2",
        boxShadow: "0 1px 3px rgba(15, 23, 42, 0.04)",
        overflow: "hidden",
      }}
    >
      {(title || action) && (
        <div
          style={{
            padding: "20px 24px",
            borderBottom: "1px solid #e8edf2",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <div style={{ flex: 1, minWidth: "200px" }}>
            {typeof title === "string" ? (
              <h2 style={{ fontSize: "18px", fontWeight: 600, margin: 0, color: "#1e293b" }}>
                {title}
              </h2>
            ) : (
              title
            )}
          </div>
          {action && <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>{action}</div>}
        </div>
      )}
      <div style={{ padding: "24px" }}>
        {children}
      </div>
    </div>
  );
};
